import { useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { RECEIPT_PREVIEW } from "@/constants/testIds";
import { toast } from "sonner";

export function ReceiptPreviewDialog({ employeeId, receipt, open, onOpenChange }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !receipt) return;
    let currentUrl = null;
    setLoading(true);
    api
      .get(`/employees/${employeeId}/receipts/${receipt.id}/download`, { responseType: "blob" })
      .then((response) => {
        currentUrl = URL.createObjectURL(response.data);
        setBlobUrl(currentUrl);
      })
      .catch(() => toast.error("No se pudo cargar el archivo."))
      .finally(() => setLoading(false));
    return () => {
      if (currentUrl) URL.revokeObjectURL(currentUrl);
      setBlobUrl(null);
    };
  }, [open, receipt, employeeId]);

  const handleDownload = () => {
    if (!blobUrl) return;
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = receipt?.original_filename || "recibo";
    a.click();
  };

  const isImage = receipt?.content_type?.startsWith("image/");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={RECEIPT_PREVIEW.dialog} className="bg-bone max-w-2xl">
        <DialogHeader>
          <DialogTitle>{receipt?.period_label}</DialogTitle>
          <DialogDescription>Vista previa de {receipt?.original_filename}</DialogDescription>
        </DialogHeader>

        <div className="bg-white rounded-xl border border-petroleum/10 h-[60vh] flex items-center justify-center overflow-hidden">
          {loading && <Loader2 className="w-6 h-6 text-petroleum animate-spin" />}
          {!loading && blobUrl && isImage && <img src={blobUrl} alt={receipt?.original_filename} className="max-h-full max-w-full object-contain" />}
          {!loading && blobUrl && !isImage && <iframe src={blobUrl} title="Vista previa del recibo" className="w-full h-full" />}
        </div>

        <Button data-testid={RECEIPT_PREVIEW.downloadButton} onClick={handleDownload} disabled={!blobUrl} className="w-full bg-petroleum rounded-full">
          <Download className="w-4 h-4 mr-2" /> Descargar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
